<template>
  <div>
    <div
      v-if="listStatus === 'block' && resultCount >= 0"
      role="status"
      class="store-result storelocator--results storelocater-col-md-12"
    >
      <p v-if="resultCount > 0">
        <span>{{ storeText }}</span> {{ resultCount }} {{ storeValue }} {{ zipcode }}
      </p>
      <p v-else-if="locationStatus">{{ geoError }}</p>
      <p v-else-if="storeList">{{ title }}</p>
      <p v-else>{{ noStore }}</p>
    </div>

    <div
      v-if="(showToggle || listStatus !== 'block') && resultCount >= 0"
      class="store-result storelocator--results storelocater-col-md-12"
    >
      <label v-if="filterLabelText != ''" for="map-display" class="stlc-storelocator-filter-label">
        {{ filterLabelText }}
      </label>
      <select
        id="map-display"
        class="storelocator__input input--text storelocater------select"
        @change="toggleOptions($event)"
      >
        <option
          v-for="option in displayFilterOptions"
          :key="option.code"
          :selected="option.code == displayMode"
          :value="option.code"
        >
          {{ option.description }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import { DisplayMode } from '../mixins/constants';

export default {
  name: 'rfp-storelocator-summary',
  props: {
    displayFilterOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
    displayMode: {
      type: String,
      required: false,
      default: DisplayMode.List,
      validator(value) {
        return Object.values(DisplayMode).includes(value);
      },
    },
    filterLabelText: {
      type: String,
      required: false,
      default: '',
    },
    geoError: {
      type: String,
      required: true,
    },
    noStore: {
      type: String,
      required: true,
    },
    storeText: {
      type: String,
      required: true,
    },
    storeValue: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      listStatus: 'block',
      locationStatus: false,
      resultCount: -1, // list hasn't loaded, positive value or 0 after
      showToggle: false,
      storeList: false,
      storeStatus: false,
      zipcode: '',
    };
  },
  created() {
    // Create a media condition that targets viewports at least 768px wide
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    if (mediaQuery.matches) {
      this.showToggle = true;
    }

    // Display the Geolocation message
    eventBus.on('locationMsg', () => {
      this.locationStatus = true;
    });

    eventBus.on('pagination_record_count', (datas) => {
      this.resultCount = datas.TotalStoreCount;
    });

    eventBus.on('postalCode', (value) => {
      this.zipcode = value;
    });

    eventBus.on('storeMsg', () => {
      this.listStatus = 'none';
      this.storeStatus = true;
    });

    eventBus.on('storeData', ({ value }) => {
      const storeDetails = value;
      if (
        document.getElementsByClassName('salonstore-list') &&
        document.getElementsByClassName('salonstore-list').length > 0
      ) {
        if (this.resultCount > 0) {
          // It's rendering based on search data
          if (this.storeStatus) {
            this.listStatus = 'block';
          }
        } else {
          // It's rendering default based on data
          this.listStatus = 'block';
        }
      } else if (storeDetails.length > 0) {
        // It's rendering only for storelocatorpdp
        this.listStatus = 'block';
        this.storeList = true;
      }
    });
  },
  methods: {
    toggleOptions($event) {
      const selectedOption = $event.target.value;

      eventBus.emit('toggleMap', selectedOption !== DisplayMode.List);
      eventBus.emit('toggleStoreList', selectedOption !== DisplayMode.Map);
    },
  },
};
</script>
